import { Typography } from "@mui/material"
import Stack from "@mui/material/Stack"
import { FC, useEffect } from "react"

import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"
import { fetchWebshopIncidents } from "src/queriesXRM/incident"
import { isAccountIncomplete } from "src/states/account"
import { SharedPageProps } from "src/types/SharedPageProps"

import { CreateRequestCard } from "./get-support/CreateRequestCard"
import { GetSupportCard } from "./get-support/GetSupportCard"
import styles from "./IncidentOverview.module.scss"
import { IncidentsTable } from "./IncidentsTable"

const bem = create(styles, "IncidentOverview")

interface IncidentOverviewProps extends SharedPageProps {}

export const IncidentOverview: FC<IncidentOverviewProps> = ({
  messages,
  page,
}) => {
  const hasIncompleteAccount = isAccountIncomplete()
  const { messages: translations } = useTranslation()
  const title = translations.pages.account.overview.navigation.support

  useEffect(() => {
    const fetchIncidents = async () => {
      await fetchWebshopIncidents()
    }
    fetchIncidents()
  }, [])

  return (
    <Stack className={bem("content")} direction={"column"} spacing={3.5}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography className={bem("title")} variant={"h1"}>
          {title}
        </Typography>
      </Stack>
      <GetSupportCard page={page} />
      <CreateRequestCard />
      {!hasIncompleteAccount && <IncidentsTable messages={messages} />}
    </Stack>
  )
}
